function permissionMatching(item, permissionAll) {
    // permissionAll = ["admin.report.sales.view", "admin.report.others.view"]
    // item.reqPermission = "admin.report.*.view"
    // where * = sales or others

    if (item?.reqPermission) {
        const reqPermission = item?.reqPermission.split('.');
        const reqPermissionLength = reqPermission.length;
        const permissionAllLength = permissionAll.length;
        let checkPermission = false;

        for (let i = 0; i < permissionAllLength; i += 1) {
            const permission = permissionAll[i].split('.');
            let check = 0;

            for (let j = 0; j < reqPermissionLength; j += 1) {
                if (reqPermission[j] === '*') {
                    check += 1;
                } else if (reqPermission[j] === permission[j]) {
                    check += 1;
                }
            }

            if (check === reqPermissionLength) {
                checkPermission = true;
                break;
            }
        }

        if (!checkPermission) {
            return true;
        }
    }

    return false;
}

export function havingPermission(item, permissionAll) {
    if (permissionAll.length === 0) {
        return true;
    }

    if (item?.subMenu) {
        // If Having Submenu
        const childPerm = item?.subMenu.map((subItem) => havingPermission(subItem, permissionAll)); // [true, true, false]

        // if all true then true
        return childPerm.includes(true);
    }

    if (item?.reqPermission && !permissionAll.includes(item?.reqPermission)) {
        // If no submenu
        return false;
    }

    return true;
}

export default permissionMatching;
